"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachCoupon = exports.getNettAmount = exports.calculateGST = exports.GST_RATE = void 0;
exports.GST_RATE = 18;
function calculateGST(amount, rate = exports.GST_RATE) {
    return parseFloat(((amount * rate) / 100).toFixed(2));
}
exports.calculateGST = calculateGST;
function getNettAmount(amount, igstAmount) {
    return parseFloat((amount + igstAmount).toFixed(2));
}
exports.getNettAmount = getNettAmount;
function attachCoupon(order, coupon) {
    if (!coupon || !order) {
        throw new Error('Order and coupon is required');
    }
    let minOrderAmount = coupon.minOrderAmount;
    // Check order amount
    if (minOrderAmount > -1) {
        if (order.netAmount < coupon.minOrderAmount) {
            throw new Error(`The minimum order amount for this coupon is INR ${coupon.minOrderAmount}`);
        }
    }
    let netAmount = order.netAmount;
    let discountRate = 0;
    let discountValue = 0;
    if (coupon.discountType === 'amount') {
        discountValue = coupon.value;
        discountRate = parseFloat(((discountValue / netAmount) * 100).toFixed(2));
    }
    else if (coupon.discountType === 'rate') {
        discountRate = coupon.value;
        discountValue = parseFloat(((netAmount * discountRate) / 100).toFixed(2));
    }
    order.discountAmount = discountValue;
    order.discountRate = discountRate;
    // Calculate gross amount
    let grossAmountAfterDiscount = order.grossAmount - order.discountAmount;
    if (grossAmountAfterDiscount < 0) {
        grossAmountAfterDiscount = order.grossAmount;
    }
    order.gstAmount = calculateGST(grossAmountAfterDiscount, order.gstRate);
    order.netAmount = getNettAmount(grossAmountAfterDiscount, order.gstAmount);
    order.netAmount = Math.round(order.netAmount);
    if (isNaN(order.grossAmount)) {
        order.grossAmount = 0;
    }
    if (isNaN(order.gstAmount)) {
        order.gstAmount = 0;
    }
    if (isNaN(order.netAmount)) {
        order.netAmount = 0;
    }
    order.discountCouponId = coupon._id;
    order.discountCouponCode = coupon.code;
    return order;
}
exports.attachCoupon = attachCoupon;
//# sourceMappingURL=Order.js.map